
namespace TabAurous.Inventory {


    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class MaterialRequestDialog extends _Ext.TransDialog<MaterialRequestRow, any> {

        protected getFormKey() { return MaterialRequestForm.formKey; }
        protected getIdProperty() { return MaterialRequestRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialRequestRow.localTextPrefix; }
        protected getNameProperty() { return MaterialRequestRow.nameProperty; }
        protected getService() { return MaterialRequestService.baseUrl; }
        protected getDeletePermission() { return MaterialRequestRow.deletePermission; }
        protected getInsertPermission() { return MaterialRequestRow.insertPermission; }
        protected getUpdatePermission() { return MaterialRequestRow.updatePermission; }
        protected useViewMode() { return true; }
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;
        public form = new MaterialRequestForm(this.idPrefix);
        TaxArray: any[];
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //    q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //  q.setGridEditorHeight(this.form.TaxDetails, 150);
            // q.hideEditorToolbar(this.form.TaxDetails.getGridField());

            //To Show Image on Right Top & Hide Categories
            //q.SetCategorySixColumn(this.form.TransDate);
            //q.SetCategoryFourColumn(this.form.BillNo);
            //q.SetCategoryFullWidth(this.form.ItemDetails);
            ////q.SetSix12Column(this.form.FinancialYearId);
            //q.SetCategorySixColumn(this.form.Pieces);
            ////q.SetCategoryThreeColumn(this.form.NetAmount);
            //q.SetCategoryFullWidth(this.form.Remark);
            //q.hideFieldsAndCategories(this.form.BillNo.element, true);
            q.HideCategoryLable(this.element);
            this.form.CompanyName.getGridField().find('.caption').attr('Style', 'display:none');


            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            var StartDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].FromDate;
            var EndDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].ToDate;


            var maxDate = new Date(EndDate);
            var minDate = new Date(StartDate);

            var _enddate = new Date().setDate(maxDate.getDate() + 1)
            var _startdate = new Date().setDate(minDate.getDate() - 1)


            this.form.TransDate.set_maxDate(new Date(_enddate));
            this.form.TransDate.set_minDate(new Date(_startdate));

            // **** Get Party Details using PartyID **** 
            //this.form.PartyId.changeSelect2(e => {

            //    let PartyDetails = OMS.VendorRow.getLookup().itemById[this.form.PartyId.value];
            //    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
            //    this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
            //    this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
            //    this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
            //    this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
            //    //this.form.GstVat.value = PartyDetails.GstVat;

            //    //let AddressDetails = OMS.AddressMasterRow.getLookup().items.filter(x => x.LedgerId == parseInt(this.form.PartyId.value))[0];
            //    //if (AddressDetails != null) {
            //    //    this.form.State.value = OMS.StatesMasterRow.getLookup().itemById[AddressDetails.State].StateName;
            //    //    this.form.Country.value = OMS.CountriesMasterRow.getLookup().itemById[AddressDetails.Country].Name;

            //    //    var city = OMS.CitiesMasterRow.getLookup().itemById[AddressDetails.City].Name;
            //    //    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
            //    //        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
            //    //    this.form.Address1.value = address;

            //    //}
            //    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
            //    //this.form.GstVat.value = PartyDetails.GstVat;
            //    this.form.GrossAmount.value = 0;

            //});

            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {

                var Items = this.form.ItemDetails.getItems(); 
                this.CalculateAmountandTax(Items );
            });


            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });


            this.validateForm();

        }

        public CalculateAmountandTax(Items: any ) {
            var ItemTotal = 0;
            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                nwt += x.NetWeight || 0;
                wt += x.Weight || 0;

                if (x.HSN != null || x.HSN != "NA") {
                    var temp = false;
                    for (let i = 0; i < codearray.length; i++) {
                        if (codearray[i] == x.HSN) {
                            amtarray[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        codearray.push(x.HSN);
                        amtarray.push(x.GrossAmount);
                    }
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            this.form.GrossAmount.value = gramt;
            this.form.Pieces.value = pcs;
            this.form.Weight.value = wt;
            this.form.NetWeight.value = nwt;
            this.form.ItemDetails.render;
        }


        protected onDialogOpen() {
            super.onDialogOpen();


            if (this.form.PartyId.value != "") {/*
                let PartyDetails = OMS.VendorRow.getLookup().itemById[this.form.PartyId.value];
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                //this.form.GstVat.value = PartyDetails.GstVat;

                //let AddressDetails = OMS.AddressMasterRow.getLookup().items.filter(x => x.LedgerId == parseInt(this.form.PartyId.value))[0];
                //if (AddressDetails != null) {
                //    this.form.State.value = OMS.StatesMasterRow.getLookup().itemById[AddressDetails.State].StateName;
                //    this.form.Country.value = OMS.CountriesMasterRow.getLookup().itemById[AddressDetails.Country].Name;

                //    var city = OMS.CitiesMasterRow.getLookup().itemById[AddressDetails.City].Name;
                //    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                //        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                //    this.form.Address1.value = address;

                //}
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);

                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                this.form.ItemDetails.itemids = itemids;
                this.form.ItemDetails.pieces = pieces;
                this.form.ItemDetails.weight = weight;
                this.form.ItemDetails.isUpdate = 1;
                this.form.ItemDetails.canUpdate = 0;
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, true);
                */
            }
            else {
                this.form.GrossAmount.value = 0;
                this.form.ItemDetails.isUpdate = 0;
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Invoice',
                cssClass: 'export-pdf-button',
                reportKey: 'Purchase.MaterialRequest',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;

            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;

            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                MaterialRequestService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        } 
        validateEntity(row: Inventory.MaterialRequestRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
        }
    }

}